import axios, { isAxiosError } from "axios";
import { useAuthStore } from "@store/auth/auth";
import { clearUserState } from "@utils/common";
import { API_URL, COUNTRY_CODE } from "@/constants";

axios.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;

    if (token) {
      config.headers.Token = token;
    }

    config.headers.CountryCode = COUNTRY_CODE;

    return config;
  },
  (error) => {
    // Logout if unauthorized
    if (
      isAxiosError(error) &&
      error.response &&
      error.response.status === 401
    ) {
      clearUserState();
    }

    return Promise.reject(error);
  },
);

axios.defaults.baseURL = API_URL;
